import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SimpleRequest, SimpleRequestSearch } from '../../../models/api-appointment/simple/simple.request.model';
import { SimpleResponse, SimpleResponseExport, SimpleResponseSearch } from '../../../models/api-appointment/simple/simple.response.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SimpleService {

  constructor(private http: HttpClient) { }
  pathUrl: string = environment.backend.pathUrl.appointment.simple;
  baseUrl: string = environment.backend.baseUrl_appuntamenti;
  url: string = this.baseUrl + this.pathUrl;

  findAll(pageNumber,pageSize):Observable<SimpleResponseSearch>{
    let url = this.url +"/" +"?pageNumber="+pageNumber+"&pageSize="+pageSize;
    return this.http.get<SimpleResponseSearch>(url);
  }

  getEntity(id: number): Observable<SimpleResponse> {
    let url = this.url +"/" + id;
    return this.http.get<SimpleResponse>(url);
  }

  update(id: number, request: SimpleRequest): Observable<SimpleResponse> {
    let url = this.url +"/" + id;
    return this.http.put<SimpleResponse>(url, request);
  }

  delete(id: number) {
    let url = this.url +"/" + id;
    return this.http.delete<any>(url);
  }

  changeStatus(id,status): Observable<SimpleResponse>{
    let url = this.url +"/" + id + "/changeStatus";
    return this.http.put<SimpleResponse>(url, status);
  }

  changeTopic(id, topicId): Observable<SimpleResponse>{
    let url = this.url +"/" + id + "/changeTopic";
    return this.http.put<SimpleResponse>(url, topicId);
  }

  sendEmailRecap(){
    let url = this.url ;
    return this.http.get<any>(url);
  }

  exportCSV():Observable<SimpleResponseExport>{
    let url = this.url +"/" +"cron/exportCsv";
    return this.http.post<SimpleResponseExport>(url,{});
  }

  search(request:SimpleRequestSearch):Observable<SimpleResponseSearch>{
    let url = this.url +"/" +"search";
    return this.http.post<SimpleResponseSearch>(url,request);
  }
}
